/**
 * searches actions
 */
import { SET_SEARCH, RESET_SEARCH } from './constants';

export function setSearch(namespace: string, search: string) {
    return {
        type: SET_SEARCH,
        payload: {
            namespace,
            search
        }
    };
}

export function resetSearch() {
    return {
        type: RESET_SEARCH
    };
}
